import { render, staticRenderFns } from "./CategoryItem.vue?vue&type=template&id=bd6515e8&"
import script from "./CategoryItem.vue?vue&type=script&lang=ts&"
export * from "./CategoryItem.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryItem.vue?vue&type=style&index=0&id=bd6515e8&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports